export default __webpack_public_path__ + "static/Plots0049-fa7ee7ed8ba492541684c5860cce61b5.jpg";